module.exports = __webpack_public_path__ + "static/img/sm_js_13.cb5428a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sm/sm_js_13.png
// module id = Qnhf
// module chunks = 1